import {useFormikContext} from 'formik';
import React, {useEffect, useState} from 'react';
import FormikDatePicker from 'src/components/formik-date-picker';
import useUserType from 'src/hooks/use-user-type/use-user-type';

interface BirthdayFormikFields {
  birthdayYear: number | '';
  birthdayMonth: number | '';
  birthdayDay: number | '';
}

const daysFromStartOfMonthUntilNow = () => {
  const now = new Date();

  return Array.from({length: now.getDate()}, (_, i) => i + 1);
};

const BirthdayInput = () => {
  // Transfers must be 15+, everyone else must be 13+ to use the app.
  const {isTransfer} = useUserType();
  const formik = useFormikContext<BirthdayFormikFields>();

  const [customMonths, setCustomMonths] = useState<{value: string; text: string}[]>();
  const [customDays, setCustomDays] = useState<{value: string; text: string}[]>();

  const now = new Date();
  const minYear = 1900;
  const maxYear = now.getFullYear() - (isTransfer ? 15 : 13);
  const maxMonth = now.getMonth();

  const customYears: {value: string; text: string}[] = [];
  for (let year = maxYear; year >= minYear; year--) {
    customYears.push({value: year.toString(), text: year.toString()});
  }

  useEffect(() => {
    if (formik.values.birthdayYear === maxYear) {
      setCustomMonths(
        Array.from({length: now.getMonth() + 1}, (_, i) => ({
          value: i.toString(),
          text: new Date(0, i).toLocaleString('default', {month: 'long'}),
        }))
      );
      if (formik.values.birthdayMonth && formik.values.birthdayMonth > maxMonth) {
        formik.setFieldValue('birthdayMonth', '');
      }
    } else {
      setCustomMonths(undefined);
    }
  }, [formik.values.birthdayYear]);

  useEffect(() => {
    if (formik.values.birthdayYear === maxYear && formik.values.birthdayMonth === maxMonth) {
      setCustomDays(
        daysFromStartOfMonthUntilNow().map((day) => ({value: String(day), text: String(day)}))
      );
    } else {
      setCustomDays(undefined);
    }
  }, [formik.values.birthdayYear, formik.values.birthdayMonth]);

  useEffect(() => {
    if (customDays && Number(formik.values.birthdayDay) > customDays.length - 1) {
      formik.setFieldValue('birthdayDay', '');
    }
  }, [customDays]);

  return (
    <FormikDatePicker
      yearName="birthdayYear"
      monthName="birthdayMonth"
      dayName="birthdayDay"
      required
      days={customDays}
      months={customMonths}
      years={customYears}
      dayLabel="Birth Day"
      monthLabel="Birth Month"
      yearLabel="Birth Year"
    />
  );
};

export default BirthdayInput;
